import { z } from "zod";

const ReservationReportDataV4Schema = z.object({
    month: z.string(),
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    nb_reservations: z.number().int(),
});

const TotalSourceV4Schema = z.object({
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    nb_reservations: z.number().int(),
});

const TotalMonthV4Schema = z.object({
    month: z.string(),
    nb_reservations: z.number().int(),
});

export const ReservationReportResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(ReservationReportDataV4Schema),
    total_source: z.array(TotalSourceV4Schema),
    total_month: z.array(TotalMonthV4Schema),
    total: z.number().int(),
});

export type ReservationReportDataV4 = z.infer<typeof ReservationReportDataV4Schema>;
export type ReservationReportResponseV4 = z.infer<typeof ReservationReportResponseV4Schema>;